export enum TypeStatusOperationEnum {
  Created = "created",
  InProgress = "in_progress",
  Success = "success",
  Failed = "failed",
  Precreated = "precreated",
  Booking = "booking",
  PendingRetry = "pending_retry",
}

export const typeStatusOperationLabels: Record<TypeStatusOperationEnum, string> = {
  [TypeStatusOperationEnum.Created]: "Created",
  [TypeStatusOperationEnum.InProgress]: "In Progress",
  [TypeStatusOperationEnum.Success]: "Success",
  [TypeStatusOperationEnum.Failed]: "Failed",
  [TypeStatusOperationEnum.Precreated]: "Precreated",
  [TypeStatusOperationEnum.Booking]: "Booking",
  [TypeStatusOperationEnum.PendingRetry]: "Pending Retry",
};

//TypeBusiness

export enum TypeBusinessEnum {
  merchant = "merchant",
  provider = "provider",
}

export interface optionEnumTypeBusinessEnum {
  value?: TypeBusinessEnum;
  label: string;
  isDisabled?: any;
}

export const optionsEnumTypeBusiness: optionEnumTypeBusinessEnum[] = [
  { value: undefined, label: "Choose one", isDisabled: "true" },
  { value: TypeBusinessEnum.merchant, label: "Мерчант" },
  { value: TypeBusinessEnum.provider, label: "Провайдер" },
];

//Currency

export enum TypeCurrencyEnum {
  NOTSET = "NOTSET",
  RUB = "RUB",
  USDT = "USDT",
  UZS = "UZS",
  KZT = "KZT",
  ARS = "ARS", // Аргентинское песо
  BOB = "BOB", // Боливиано
  BRL = "BRL", // Бразильский реал
  CLP = "CLP", // Чилийский песо
  COP = "COP", // Колумбийский песо
  USD = "USD", // Доллар США
  GYD = "GYD", // Гайанский доллар
  PYG = "PYG", // Парагвайский гуарани
  PEN = "PEN", // Перуанский соль
  SRD = "SRD", // Суринамский доллар
  UYU = "UYU", // Уругвайское песо
  VES = "VES", // Венесуэльский боливар
  EUR = "EUR", // Евро
  FKP = "FKP", // Фолклендский фунт
  AZN = "AZN", // Азербайджанский манат
}

export interface optionEnumTypeCurrencyEnum {
  value?: TypeCurrencyEnum;
  label: string;
  isDisabled?: any;
}

export const optionsTypeCurrencyEnum: optionEnumTypeCurrencyEnum[] = [
  { value: undefined, label: "Choose one", isDisabled: "true" },
  { value: TypeCurrencyEnum.NOTSET, label: "Не установлено" },
  { value: TypeCurrencyEnum.RUB, label: "Рубль" },
  { value: TypeCurrencyEnum.USDT, label: "USDT" },
  { value: TypeCurrencyEnum.UZS, label: "Узбекский сум" },
  { value: TypeCurrencyEnum.KZT, label: "Тенге" },
  { value: TypeCurrencyEnum.ARS, label: "Аргентинское песо" },
  { value: TypeCurrencyEnum.BOB, label: "Боливиано" },
  { value: TypeCurrencyEnum.BRL, label: "Бразильский реал" },
  { value: TypeCurrencyEnum.CLP, label: "Чилийский песо" },
  { value: TypeCurrencyEnum.COP, label: "Колумбийский песо" },
  { value: TypeCurrencyEnum.USD, label: "Доллар США (Эквадор)" },
  { value: TypeCurrencyEnum.GYD, label: "Гайанский доллар" },
  { value: TypeCurrencyEnum.PYG, label: "Парагвайский гуарани" },
  { value: TypeCurrencyEnum.PEN, label: "Перуанский соль" },
  { value: TypeCurrencyEnum.SRD, label: "Суринамский доллар" },
  { value: TypeCurrencyEnum.UYU, label: "Уругвайское песо" },
  { value: TypeCurrencyEnum.VES, label: "Венесуэльский боливар" },
  { value: TypeCurrencyEnum.EUR, label: "Евро (Французская Гвиана)" },
  { value: TypeCurrencyEnum.FKP, label: "Фолклендский фунт" },
  { value: TypeCurrencyEnum.AZN, label: "Азербайджанский манат" },
];

//TypePaymentMethodEnum

export enum TypePaymentMethodEnum {
  toCard = "toCard",
  sbp = "sbp",
  toAccount = "toAccount",
  transgran = "transgran",
  transgranSBP = "transgranSBP",
  nspk = "nspk",

  alfa_alfa = "alfa_alfa",
  sber_sber = "sber_sber",
  ozon_ozon = "ozon_ozon",
  tbank_tbank = "tbank_tbank",
  vtb_vtb = "vtb_vtb",
  gazprom_gazprom = "gazprom_gazprom",
  psb_psb = "psb_psb",
  ecom = "ecom",
  mobile = "mobile",
  azn_c2c = "azn_c2c",
  azn_quasi = "azn_quasi",
}

export const typePaymentMethodLabels: Record<TypePaymentMethodEnum, string> = {
  [TypePaymentMethodEnum.toCard]: "Карты",
  [TypePaymentMethodEnum.sbp]: "СБП",
  [TypePaymentMethodEnum.toAccount]: "Р/С",
  [TypePaymentMethodEnum.transgran]: "Трансгран",
  [TypePaymentMethodEnum.transgranSBP]: "Трансгран СБП",
  [TypePaymentMethodEnum.nspk]: "НСПК",
  [TypePaymentMethodEnum.alfa_alfa]: "alfa_alfa",
  [TypePaymentMethodEnum.sber_sber]: "sber_sber",
  [TypePaymentMethodEnum.ozon_ozon]: "ozon_ozon",
  [TypePaymentMethodEnum.tbank_tbank]: "tbank_tbank",
  [TypePaymentMethodEnum.vtb_vtb]: "vtb_vtb",
  [TypePaymentMethodEnum.gazprom_gazprom]: "gazprom_gazprom",
  [TypePaymentMethodEnum.psb_psb]: "psb_psb",
  [TypePaymentMethodEnum.ecom]: "Ecom",
  [TypePaymentMethodEnum.mobile]: "Mobile",
  [TypePaymentMethodEnum.azn_c2c]: "AZN C2C",
  [TypePaymentMethodEnum.azn_quasi]: "AZN Quasi",
};

export interface optionEnumTypePaymentMethodEnum {
  value?: TypePaymentMethodEnum;
  label: string;
  isDisabled?: any;
}

export const optionsEnumTypePaymentMethod: optionEnumTypePaymentMethodEnum[] = [
  { value: undefined, label: "Choose one", isDisabled: "true" },
  { value: TypePaymentMethodEnum.toCard, label: "На карту" },
  { value: TypePaymentMethodEnum.sbp, label: "СБП" },
  { value: TypePaymentMethodEnum.toAccount, label: "На счёт" },
  { value: TypePaymentMethodEnum.transgran, label: "Трансгран" },
  { value: TypePaymentMethodEnum.transgranSBP, label: "Трансгран СБП" },
  { value: TypePaymentMethodEnum.nspk, label: "НСПК" },

  { value: TypePaymentMethodEnum.alfa_alfa, label: "alfa_alfa" },
  { value: TypePaymentMethodEnum.sber_sber, label: "sber_sber" },
  { value: TypePaymentMethodEnum.ozon_ozon, label: "ozon_ozon" },
  { value: TypePaymentMethodEnum.tbank_tbank, label: "tbank_tbank" },
  { value: TypePaymentMethodEnum.vtb_vtb, label: "vtb_vtb" },
  { value: TypePaymentMethodEnum.gazprom_gazprom, label: "gazprom_gazprom" },
  { value: TypePaymentMethodEnum.psb_psb, label: "psb_psb" },
  { value: TypePaymentMethodEnum.ecom, label: "Ecom" },
  { value: TypePaymentMethodEnum.mobile, label: "Mobile" },
  { value: TypePaymentMethodEnum.azn_c2c, label: "AZN C2C" },
  { value: TypePaymentMethodEnum.azn_quasi, label: "AZN Quasi" },
];

//TypeOperationEnum

export enum TypeOperationEnum {
  PayIn = "payIn",
  PayOut = "payOut",
  BalanceReplenishment = "balanceReplenishment",
}

export const typeOperationLabels: Record<TypeOperationEnum, string> = {
  [TypeOperationEnum.PayIn]: "Pay In",
  [TypeOperationEnum.PayOut]: "Pay Out",
  [TypeOperationEnum.BalanceReplenishment]: "Balance Replenishment",
};

export interface optionEnumTypeOperationEnum {
  value?: TypeOperationEnum;
  label: string;
  isDisabled?: any;
}

export const optionsEnumTypeOperation: optionEnumTypeOperationEnum[] = [
  { value: undefined, label: "Choose one", isDisabled: "true" },
  { value: TypeOperationEnum.PayIn, label: "PayIn" },
  { value: TypeOperationEnum.PayOut, label: "PayOut" },
  { value: TypeOperationEnum.BalanceReplenishment, label: "Balance" },
];

export enum TypeSourseDateEnum {
    Added = "addedd",
    DateFinalCalculation = "dateFinalCalculation"
}

export const typeSourseDateLabels: Record<TypeSourseDateEnum, string> = {
    [TypeSourseDateEnum.Added]: "Создание",
    [TypeSourseDateEnum.DateFinalCalculation]: "Закрытие"
};
